export default __webpack_public_path__ + "static/media/006-family-2.97895ac8.png";